// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import store from './store/store.js';

Vue.use(ViewUI);

// ========== 全局错误处理 ==========
Vue.config.errorHandler = function(err, vm, info) {
  console.error('[Vue Error]', info, err);
};

// ========== 事件总线 ==========
Vue.prototype.$bus = new Vue()

// ========== Cookie 操作 ==========
Vue.prototype.setCookie = function(c_name, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = c_name + "=" + escape(value) +
    ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())
};

Vue.prototype.deleteCookie = function(c_name) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() - 1); // 将过期日期设置为昨天
  document.cookie = c_name + "=; expires=" + exdate.toGMTString();
};

Vue.prototype.getCookie = function(c_name) {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(c_name + "=")
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1
      var c_end = document.cookie.indexOf(";", c_start)
      if (c_end == -1) c_end = document.cookie.length
      return unescape(document.cookie.substring(c_start, c_end))
    }
  }
  return ""
};

// ========== HTTP 配置 ==========
Vue.prototype.$http = axios
Vue.config.productionTip = false

function getViewportInfo() {
  const width = window.innerWidth || document.documentElement.clientWidth || 0
  const height = window.innerHeight || document.documentElement.clientHeight || 0
  return {
    width,
    height,
    isMobile: width <= 768,
    isTablet: width > 768 && width <= 1200
  }
}

function applyViewportState() {
  if (typeof window === 'undefined') return
  const viewport = getViewportInfo()
  store.commit('setResponsive', viewport)
  const root = document.documentElement
  const body = document.body
  root.style.setProperty('--app-height', `${viewport.height}px`)
  root.classList.toggle('is-mobile', viewport.isMobile)
  root.classList.toggle('is-tablet', viewport.isTablet)
  root.classList.toggle('is-desktop', !viewport.isMobile && !viewport.isTablet)
  if (body) {
    body.classList.toggle('is-mobile', viewport.isMobile)
    body.classList.toggle('is-tablet', viewport.isTablet)
    body.classList.toggle('is-desktop', !viewport.isMobile && !viewport.isTablet)
  }
}

Vue.prototype.$getViewportInfo = getViewportInfo

// 修正 axios baseURL
/*axios.defaults.baseURL = "http://1.15.75.55/foodie-api"  // 添加完整URL
axios.defaults.timeout = 15000*/

// 请求拦截器
axios.interceptors.request.use(config => {
  // 从 localStorage 获取 token（与 Im.vue 保持一致）
  const token = localStorage.getItem('token') || Vue.prototype.getCookie("token")
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
})

// 响应拦截器
axios.interceptors.response.use(null, (error) => {
  // 如果状态码是401，表示token过期
  if (error.response && error.response.status === 401) {
    // 清除所有存储的认证信息
    Vue.prototype.deleteCookie('token');
    localStorage.removeItem('token');
    localStorage.removeItem('userActivity');
    sessionStorage.removeItem('user');

    // 跳转到登录页面
    router.push('/');
  }
  // 返回error，让其他的响应错误拦截器可以继续处理
  return Promise.reject(error);
});

// ========== WebSocket 全局管理 ==========
let globalChatWebSocket = null;
let heartbeatInterval = null;
let reconnectAttempts = 0;
let syncCharacterInterval = null;
const MAX_RECONNECT_ATTEMPTS = 5;
const RECONNECT_INTERVAL = 5000; // 5秒
const SYNC_INTERVAL = 900000; // 15分钟

// 获取当前用户信息（统一方法）
function getCurrentUser() {
  // 优先从 localStorage 获取（与 Im.vue 保持一致）
  const userData = JSON.parse(localStorage.getItem("userActivity")) || {};
  if (userData && userData.account) {
    return userData;
  }

  // 其次从 sessionStorage 获取
  const sessionUser = JSON.parse(sessionStorage.getItem('user')) || {};
  if (sessionUser && sessionUser.account) {
    return sessionUser;
  }

  // 从 cookie 获取
  const cookieToken = Vue.prototype.getCookie("user");
  if (cookieToken) {
    try {
      return JSON.parse(cookieToken);
    } catch (e) {
      console.error('解析用户信息失败:', e);
    }
  }

  return null;
}

// 初始化全局 WebSocket 连接
function initGlobalWebSocket() {
  // 获取用户信息
  const user = getCurrentUser();
  if (!user || !user.account) {
    console.log('未登录，不初始化 WebSocket');
    return;
  }

  // 如果已存在连接，先关闭
  if (globalChatWebSocket) {
    globalChatWebSocket.close();
    globalChatWebSocket = null;
  }

  // 清除之前的心跳定时器
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
  if (syncCharacterInterval) {
    clearInterval(syncCharacterInterval);
    syncCharacterInterval = null;
  }

  try {
    // 修正 WebSocket URL（与后端保持一致）
    const webSocketLink = `ws://1.15.75.55/foodie-api/imserver/${user.account}`;
    console.log('正在初始化全局 WebSocket 连接:', webSocketLink);

    globalChatWebSocket = new WebSocket(webSocketLink);

    // 连接成功
    globalChatWebSocket.onopen = function(event) {
      console.log('全局 WebSocket 连接成功');
      reconnectAttempts = 0; // 重置重连次数

      // 发送连接成功消息到事件总线
      Vue.prototype.$bus.$emit('GLOBAL_WS_OPEN', event);

      // 设置心跳包
      // 修改第75-79行：
      heartbeatInterval = setInterval(() => {
        if (globalChatWebSocket && globalChatWebSocket.readyState === WebSocket.OPEN) {
          // 发送JSON格式的心跳消息
          const heartbeatMsg = JSON.stringify({
            type: "HeartBeat",
            timestamp: Date.now()
          });
          globalChatWebSocket.send(heartbeatMsg);
          console.log('发送心跳:', heartbeatMsg);
        }
      }, 30000); // 30秒一次心跳

      // 角色信息同步函数
      const syncCharacter = () => {
        try {
          const appElement = document.querySelector('#app');
          if (appElement && appElement.__vue__) {
            const vueInstance = appElement.__vue__;
            if (vueInstance.updateAllcharacter) {
              vueInstance.updateAllcharacter();
            }
          }
        } catch (error) {
          console.error('同步角色信息失败:', error);
        }
      };

      // 立即执行一次
      syncCharacter();

      // 然后每隔15分钟执行一次
      syncCharacterInterval = setInterval(syncCharacter, SYNC_INTERVAL);
    };

    // 收到消息
    globalChatWebSocket.onmessage = function(event) {
      // 将消息转发到事件总线
      Vue.prototype.$bus.$emit('GLOBAL_WS_MESSAGE', event.data);

      try {
        const data = JSON.parse(event.data);
        console.log('收到 WebSocket 消息:', data);

        // 村口频道消息广播
        if (data.pindao === '桑林村村口' || data.pindao === 'village') {
          Vue.prototype.$bus.$emit('VILLAGE_MESSAGE', data);
        }

        // 系统消息广播
        if (data.type === 'system') {
          Vue.prototype.$bus.$emit('SYSTEM_MESSAGE', data);
        }

        // 新消息广播
        if (data.text && data.from) {
          Vue.prototype.$bus.$emit('NEW_CHAT_MESSAGE', data);
        }

       // 在线用户更新
        if (data.users) {
          // 传递完整数据对象，包含 silent 标记
          Vue.prototype.$bus.$emit('ONLINE_USERS_UPDATE', {
            users: data.users,
            silent: data.silent || false,  // 后端传来的静默标记，默认为 false
            timestamp: data.timestamp
          });
          
          // 静默模式下不触发系统消息提醒
          if (!data.silent) {
            console.log('在线用户更新（非静默）:', data.users.length, '人');
          } else {
            console.log('在线用户更新（静默）:', data.users.length, '人');
          }
        }

        // 错误消息
        if (data.type === 'error') {
          Vue.prototype.$bus.$emit('WS_ERROR_MESSAGE', data);
        }

      } catch (e) {
        console.error('解析 WebSocket 消息失败:', e, event.data);
      }
    };

    // 连接错误
    globalChatWebSocket.onerror = function(event) {
      console.error('全局 WebSocket 连接错误:', event);
      Vue.prototype.$bus.$emit('GLOBAL_WS_ERROR', event);
    };

    // 连接关闭
    globalChatWebSocket.onclose = function(event) {
      console.log('全局 WebSocket 连接关闭:', event);
      Vue.prototype.$bus.$emit('GLOBAL_WS_CLOSE', event);

      // 清除心跳定时器
      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
        heartbeatInterval = null;
      }
      if (syncCharacterInterval) {
        clearInterval(syncCharacterInterval);
        syncCharacterInterval = null;
      }

      // 尝试重连
      if (event.code !== 1000) { // 1000 是正常关闭
        reconnectAttempts++;
        if (reconnectAttempts <= MAX_RECONNECT_ATTEMPTS) {
          console.log(`尝试重连 (${reconnectAttempts}/${MAX_RECONNECT_ATTEMPTS})...`);
          setTimeout(() => {
            initGlobalWebSocket();
          }, RECONNECT_INTERVAL);
        } else {
          console.log('达到最大重连次数，停止重连');
          Vue.prototype.$bus.$emit('WS_CONNECTION_LOST');
        }
      }
    };

    // 挂载到 window 对象，方便访问
    window.chatWebSocket = globalChatWebSocket;

    // 在 Vue 原型上提供发送消息的方法
    Vue.prototype.$sendChatMessage = function(message) {
      if (globalChatWebSocket && globalChatWebSocket.readyState === WebSocket.OPEN) {
        try {
          const jsonMessage = JSON.stringify(message);
          console.log('发送 WebSocket 消息:', jsonMessage);
          globalChatWebSocket.send(jsonMessage);
          return true;
        } catch (error) {
          console.error('发送消息失败:', error);
          Vue.prototype.$bus.$emit('WS_SEND_ERROR', error);
          return false;
        }
      } else {
        console.warn('WebSocket 未连接，无法发送消息');
        Vue.prototype.$bus.$emit('WS_NOT_CONNECTED');
        return false;
      }
    };

    // 检查连接状态的方法
    Vue.prototype.$checkChatConnection = function() {
      if (!globalChatWebSocket) return false;
      return globalChatWebSocket.readyState === WebSocket.OPEN;
    };

    // 重新连接方法
    Vue.prototype.$reconnectChat = function() {
      reconnectAttempts = 0;
      initGlobalWebSocket();
    };

  } catch (error) {
    console.error('初始化 WebSocket 失败:', error);
    Vue.prototype.$bus.$emit('WS_INIT_ERROR', error);
  }
}

// 在 Vue 原型上挂载初始化方法
Vue.prototype.$initChatConnection = initGlobalWebSocket;

// ========== 页面生命周期管理 ==========

// 页面加载完成后初始化 WebSocket
let initTimeout = null;
function initAfterPageLoad() {
  // 【临时屏蔽 WebSocket】
  console.log('WebSocket 已临时屏蔽');
  return;

  // 延迟初始化，确保页面完全加载
  if (initTimeout) clearTimeout(initTimeout);
  initTimeout = setTimeout(() => {
    const user = getCurrentUser();
    if (user && user.account) {
      initGlobalWebSocket();
    } else {
      console.log('用户未登录，跳过 WebSocket 初始化');
    }
  }, 2000); // 延迟 2 秒，确保页面完全加载
}

// 监听页面加载事件
if (document.readyState === 'loading') {
  window.addEventListener('load', initAfterPageLoad);
} else {
  // 如果页面已经加载完成，直接初始化
  initAfterPageLoad();
}

let viewportResizeTimer = null
if (typeof window !== 'undefined') {
  applyViewportState()
  window.addEventListener('resize', function() {
    if (viewportResizeTimer) {
      clearTimeout(viewportResizeTimer)
    }
    viewportResizeTimer = setTimeout(() => {
      applyViewportState()
    }, 80)
  });
  window.addEventListener('orientationchange', function() {
    applyViewportState()
  });
}

// 监听页面可见性变化（用户切换标签页时）
document.addEventListener('visibilitychange', function() {
  if (!document.hidden) {
    // 页面可见时，检查 WebSocket 连接状态
    if (!globalChatWebSocket || globalChatWebSocket.readyState !== WebSocket.OPEN) {
      console.log('页面重新可见，重新连接 WebSocket');
      initAfterPageLoad();
    }
  }
});

// 监听用户登录事件
Vue.prototype.$bus.$on('USER_LOGIN', function(userData) {
  console.log('用户登录事件触发，初始化 WebSocket');
  // 保存用户信息到 localStorage（与 Im.vue 保持一致）
  if (userData) {
    localStorage.setItem('userActivity', JSON.stringify(userData));
  }
  // 初始化 WebSocket
  initAfterPageLoad();
});

// 监听用户登出事件
Vue.prototype.$bus.$on('USER_LOGOUT', function() {
  console.log('用户登出，关闭 WebSocket');
  // 清除用户信息
  localStorage.removeItem('userActivity');
  sessionStorage.removeItem('user');
  Vue.prototype.deleteCookie('token');
  localStorage.removeItem('token');

  // 关闭 WebSocket
  if (globalChatWebSocket) {
    globalChatWebSocket.close();
    globalChatWebSocket = null;
  }
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
  if (syncCharacterInterval) {
    clearInterval(syncCharacterInterval);
    syncCharacterInterval = null;
  }
  reconnectAttempts = 0;
});

// ========== 路由守卫（可选）==========
router.beforeEach((to, from, next) => {
  // 如果需要登录的页面，检查用户是否登录
  if (to.meta.requiresAuth) {
    const user = getCurrentUser();
    if (!user || !user.account) {
      next('/'); // 跳转到登录页
      return;
    }
  }
  next();
});
axios.defaults.baseURL = "foodie-api"
axios.defaults.timeout = 15000
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js